import { setMeasurement } from '@sentry/react';
import { SynopticLogoIcon } from '@synoptic/ui-kit/icons/react/synoptic-logo.js';
import { lightTheme } from '@synoptic/ui-kit/theme/theme.css.js';
import { clsx } from 'clsx';
import { useEffect } from 'react';
import { splashScreen, splashScreenLogo } from './splash-screen.css';

export const SplashScreen = ({
  forcedLightMode,
}: {
  forcedLightMode?: boolean;
}) => {
  useEffect(() => {
    return () => {
      setMeasurement('ui.splash_screen.hide', performance.now(), 'millisecond');
    };
  });

  return (
    <div
      id="splash-screen"
      className={clsx(splashScreen, forcedLightMode && lightTheme)}
    >
      <SynopticLogoIcon className={splashScreenLogo} />
    </div>
  );
};
